import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import Papa from 'papaparse';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let BaseCsvImporter = class BaseCsvImporter extends Mixins(ViewportSizeMixin) {
    fileChange(e) {
        const file = e.target.files[0];
        Papa.parse(file, {
            header: true,
            delimiter: ',',
            skipEmptyLines: true,
            complete: (result) => {
                this.$emit('imported-data', result.data);
            },
        });
        const vm = this;
        vm.$refs.file.value = '';
    }
    get vueClass() {
        if (this.xsOnly) {
            return 'pa-0';
        }
        if (this.lgAndDown) {
            return 'px-2';
        }
        return '';
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], BaseCsvImporter.prototype, "requestOnProcess", void 0);
__decorate([
    Prop({ type: String, default: 'Import' })
], BaseCsvImporter.prototype, "buttonName", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseCsvImporter.prototype, "iconable", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseCsvImporter.prototype, "orangeTheme", void 0);
BaseCsvImporter = __decorate([
    Component({
        components: {
            ActionButton,
            Papa,
        },
    })
], BaseCsvImporter);
export default BaseCsvImporter;
